module.exports = __webpack_public_path__ + "img/RH2020N.047b18ad.png";